Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    optionListItemMobileSpacingInsetVertical: 16,
    optionListItemMobileSpacingInsetHorizontal: 16,
    optionListItemSpacingInsetVertical: 8,
    optionListItemSpacingInsetHorizontal: 12,
    optionListItemForegroundColorDefault: tokens.themeForegroundPrimaryDefault,
    optionListItemForegroundColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListItemForegroundColorPreselected: tokens.themeForegroundInvertedDefault,
    optionListItemForegroundColorPressed: tokens.themeForegroundInvertedDefault,
    optionListItemForegroundColorSelected: tokens.themeForegroundInvertedDefault,
    optionListItemBackgroundColorDefault: tokens.themeBackgroundPrimaryDefault,
    optionListItemBackgroundColorDisabled: tokens.themeBackgroundPrimaryDefault,
    optionListItemBackgroundColorPreselected: tokens.themeForegroundAccentHover,
    optionListItemBackgroundColorPressed: tokens.themeForegroundAccentPressed,
    optionListItemBackgroundColorSelected: tokens.themeForegroundAccentDefault,
    optionListItemIndicatorColorDefault: "rgba(0, 0, 0, 0)",
    optionListItemIndicatorColorDisabled: tokens.themeForegroundPrimaryDisabled,
    optionListItemIndicatorColorPreselected: tokens.themeForegroundAccentDefault,
    optionListItemIndicatorColorPressed: tokens.themeForegroundInvertedDefault,
    optionListItemIndicatorColorSelected: tokens.themeForegroundInvertedDefault,
    optionListItemMotionDuration: "100ms",
    optionListItemMotionFunction: "ease",
    optionListItemLineHeight: "24px"
  }
};